import * as React from "react";
import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { connect } from "react-redux";
import {
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Autocomplete,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import config, { Creators as CreatorsConfig } from "../store/ducks/config";
import { styles } from "../theme/styles";
import providers, {
  Creators as ProvidersCreators,
} from "../store/ducks/providers";
import { CustomButton } from "../components/CustomButton";
import AgregarProveedorModal from "./AgregarProveedorModal";
import DetalleProveedorModal from "./DetalleProveedorModal";
import EditarClustersModal from "./EditarClustersModal";
import EditarMinimosModal from "./EditarMinimosModal";
import SnackBar from "../components/SnackBarCustom";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { ClipLoader } from "react-spinners";
import { styled } from "@mui/material/styles";
import Swal from "sweetalert2";
import axios from "axios";
import "../index.css";

function AdministradorPage(props) {
  const fileInputRef = useRef(null);
  const [editedPrices, setEditedPrices] = useState({});
  const [errorPrices, setErrorPrices] = useState({});
  const [dataMaterialAuxiliar, setDataMaterialAuxiliar] = useState({});
  const hayCambios = Object.keys(editedPrices).length > 0;
  const [loadingTablaSubcat, setLoadingTablaSubcat] = useState(false);
  const [loadingAlta, setLoadingAlta] = useState(false);
  const {
    redirectToPasswordScreen,
    providers,
    getAllProviders,
    getProviderById,
    updateMaterial,
    createProvider,
    createMaterial,
    deleteMaterial,
    desactiveProvider,
    token,
    loading,
    loadingProviders,
    message,
    clearMessage,
    users,
    addMatProvider,
  } = props;
  const [clusters, setClusters] = useState([]);
  const [dataProvider, setDataProvider] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [mostrarSpiner, setMostrarSpiner] = useState(true);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [clusterSelect, setClusterSelect] = useState("");
  const [selectedFiltro, setSelectedFiltro] = useState("");
  const [proveedor, setProveedor] = useState(null);
  const [isManual, setIsManual] = useState(false);
  const [ventanaProve, setVentanaProve] = useState(null);
  const [selectedMat, setSelectedMat] = useState(null);
  const [idSelectedMat, setIdSelectedMat] = useState(null);
  const [auxiliar, setAuxiliar] = useState("");
  const [altaMaterial, setAltaMaterial] = useState(false);
  const [cargaMaterial, setCargaMaterial] = useState(false);
  const [idNuevo, setIdNuevo] = useState("");
  const [materialNuevo, setMaterialNuevo] = useState();
  const [idSubcategoriaNuevo, setIdSubCategoriaNuevo] = useState();
  const [nombreCategoriaNuevo, setNombreCategoriaNuevo] = useState();
  const [precioNuevo, setPrecioNuevo] = useState();
  const [nombreCientifico, setNombreCientifo] = useState();
  const [file, setFile] = useState(null);
  const [arrClusterSeleccionado, setArrClusterSeleccionado] = useState([]);
  const [checkboxTotal, setCheckboxTotal] = useState(false);
  const [selectedGuia, setSelectedGuia] = useState("");

  const [newProvider, setNewProvider] = useState({
    idNumber: "",
    nameProvider: "",
    email: "",
    sucursalAsignada: "",
  });
  const [subCatMats, setSubCatMats] = useState([]);
  const [mostrarSeleccion, setMostrarSeleccion] = useState(false);
  const [tiendas, setTiendas] = useState(null);
  const [errNewProvider, setErrNewProvider] = useState({
    nombre: false,
    id: false,
    idRepeated: false,
    mail: false,
    mailRegEx: false,
    clusters: false,
    subcategoria: false,
  });
  const [errNewMaterial, setErrNewMaterial] = useState({
    description: false,
    dupli: false,
    material: false,
    subCategoryId: false,
    subCategoryName: false,
    price: false,
    nombreCientifico: false,
  });
  const [errCargaMaterial, setErrCargaMaterial] = useState({
    subCat: false,
    material: false,
    price: false,
  });
  const [subcategories, setSubcategories] = useState(null);
  const [newSubcategories, setNewSubcategories] = useState(null);
  const [newMateriales, setNewMateriales] = useState([]);
  const [previewUrl, setPreviewUrl] = useState("");
  const [viewGuia, setViewGuia] = useState(false);
  const [guias, setGuias] = useState([]);
  const [categoriaSelected, setCategoriaSelected] = useState([]);

  // Detalle / edición de proveedor (pantalla 3)
  const [detalleProveedorAbierto, setDetalleProveedorAbierto] = useState(false);
  const [proveedorEnDetalle, setProveedorEnDetalle] = useState(null);
  const [editModal, setEditModal] = useState(null); // "clusters" | "minimos" | null
  const [pendingMontoInicial, setPendingMontoInicial] = useState(null);

  const materialesFiltrados = newMateriales
    ? newMateriales.filter(
        (item) => item.SUBCATEGORIA_ID === idSubcategoriaNuevo,
      )
    : [];

  const handleGuiaChange = (event) => {
    const guiaSeleccionada = event.target.value;
    setSelectedGuia(guiaSeleccionada);
    setErrNewMaterial((prev) => ({
      ...prev,
      guia: false,
    }));
    setFile(null);
  };

  const openGuia = () => {
    if (!selectedGuia) {
      Swal.fire({
        title: "Selecciona una guía para visualizarla",
        icon: "info",
        iconColor: "#001F5B",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
      });
    }
    setViewGuia(true);
    const rutaGuia = `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/getArchivoDir/${selectedGuia}`;
    setPreviewUrl(rutaGuia);
  };

  const closeGuia = () => {
    setViewGuia(false);
    setPreviewUrl(null);
  };

  const handleChange = (e, material) => {
    const valor = e.target.value;

    const regex = /^(?!\.)(\d+(\.\d*)?)?$/;
    if (regex.test(valor)) {
      const materialModificado = {
        ...material,
        price: valor,
      };

      setEditedPrices((prev) => ({
        ...prev,
        [material.description]: valor,
      }));

      setDataMaterialAuxiliar((prev) => ({
        ...prev,
        [material.description]: materialModificado,
      }));

      setErrorPrices((prev) => ({
        ...prev,
        [material.description]:
          valor === "" || parseFloat(valor) === 0 ? true : false,
      }));
    }
  };

  const handleDeleteFile = async (e) => {
    setFile(null);
  };

  const handleArchivoChange = async (e) => {
    try {
      const guia = e.target.files[0];
      if (!guia) return;

      if (!guia.type.startsWith("image/")) {
        Swal.fire({
          title: "Solo se permiten imágenes",
          icon: "info",
          iconColor: "#001F5B",
          confirmButtonColor: "#001F5B",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "swal-legal",
          },
        });
        e.target.value = "";
        return;
      }

      setSelectedGuia("");
      setFile(guia);

      setErrNewMaterial((prev) => ({
        ...prev,
        guia: false,
      }));
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "No se pudo subir imagen, intentálo de nuevo",
        icon: "error",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "swal-legal",
        },
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      e.target.value = "";
    }
  };

  const filteredProveedores = dataTable.filter((c) => {
    const lowerSearchTerm = selectedFiltro.toLowerCase();
    const proveedorName = c.name?.toString().toLowerCase() || "";
    const proveedorId = c.idNumber?.toString().toLowerCase() || "";
    const clusters = c.clusters?.map((cl) => cl.toLowerCase()) || [];

    const searchMatch =
      proveedorName.includes(lowerSearchTerm) ||
      proveedorId.includes(lowerSearchTerm) ||
      clusters.some((cl) => cl.includes(lowerSearchTerm));

    return searchMatch;
  });

  const hanldeProveedor = async (data) => {
    getProviderById(token, data);
  };

  const filterBySubcategory = async (subName) => {
    const ID = subcategories.filter(
      (sub) => sub.SUBCATEGORIA_NOMBRE === subName,
    )[0].SUBCATEGORIA_ID;

    setLoadingTablaSubcat(true);
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/info/getItemsSubcategory/${ID}
      `,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        },
      );

      setSubCatMats(
        res.data.data.map((mat) => ({
          ...mat,
          idOriginal: mat.MATERIAL_ID,
          checked: false,
          stock: 0,
          price: 0.0,
        })),
      );
      setLoadingTablaSubcat(false);
    } catch (e) {
      setLoadingTablaSubcat(false);
    }
  };

  const getSubcategories = async () => {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/info/getSubcategory
      `,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        },
      );
      setSubcategories(res.data.data);
    } catch (e) {}
  };

  useEffect(() => {
    getSubcategories();
  }, []);

  const getNewSubcategories = async (opt) => {
    try {
      if (opt === "1") setLoadingAlta(true);
      let res = await axios.get(
        `${process.env.REACT_APP_API_PETCOZOO}/info/getNewItems
      `,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (opt === "1") setLoadingAlta(false);
      const mats = res.data.data;
      if (mats.length > 0) {
        setNewMateriales(mats);
        const subcategoriasUnicas = Array.from(
          new Map(
            mats.map((item) => [
              item.SUBCATEGORIA_ID,
              {
                SUBCATEGORIA_ID: item.SUBCATEGORIA_ID,
                SUBCATEGORIA_NOMBRE: item.SUBCATEGORIA_NOMBRE,
              },
            ]),
          ).values(),
        );
        setNewSubcategories(subcategoriasUnicas);
        if (opt === "1") setAltaMaterial(true);
      } else if (mats.length == 0) {
        if (opt === "1") {
          Swal.fire({
            title: "No hay materiales nuevos",
            text: "Inténtalo de nuevo",
            icon: "info",
            iconColor: "#001F5B",
            confirmButtonColor: "#001F5B",
            confirmButtonText: "Aceptar",
          });
        }
      }
    } catch (error) {
      setLoadingAlta(false);
      console.log("ERROR AL OBTENER SUBCATEGORIAS", error);
      if (opt === "1") {
        Swal.fire({
          title: "No se pudo obtener nuevos materiales",
          text: "Inténtalo de nuevo",
          icon: "error",
          iconColor: "#001F5B",
          confirmButtonColor: "#001F5B",
          confirmButtonText: "Aceptar",
        });
      }
      setAltaMaterial(false);
      setNewSubcategories(null);
      setNewMateriales(null);
      setIdNuevo(null);
      setMaterialNuevo(null);
      setIdSubCategoriaNuevo(null);
      setNombreCategoriaNuevo(null);
      setPrecioNuevo(null);
    }
  };

  // Antes leía de los estados globales newProvider/arrClusterSeleccionado/
  // selectedSubcategory (llenados por el formulario inline). Ahora
  // AgregarProveedorModal arma ese objeto y lo manda completo aquí.
  const handleShowTable = async (formData) => {
    const providerExist = dataProvider.filter(
      (provider) => provider.idNumber === formData.idNumber,
    );

    if (providerExist.length > 0) {
      Swal.fire({
        title: "Ese ID de proveedor ya existe",
        icon: "info",
        iconColor: "#001F5B",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setNewProvider({
      idNumber: formData.idNumber,
      nameProvider: formData.nameProvider,
      email: formData.email,
      sucursalAsignada: formData.sucursalAsignada,
    });
    setArrClusterSeleccionado(formData.clusters);
    setSelectedSubcategory(formData.subcategoria);
    setPendingMontoInicial(formData.montoInicial || null);

    await filterBySubcategory(formData.subcategoria);
    setMostrarSeleccion(true);
  };

  const handleCreateProvider = async (materiales) => {
    if (
      !newProvider.idNumber ||
      !newProvider.nameProvider ||
      !newProvider.email ||
      !arrClusterSeleccionado
    ) {
      Swal.fire({
        title: "Antes de continuar, deberás llenar todos los datos",
        icon: "info",
        iconColor: "#001F5B",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "swal-legal",
        },
      });
    } else {
      const providerEnvia = {
        ...newProvider,
        actualInventory: materiales.filter((mat) => mat.checked),
      };
      try {
        await axios.post(
          `${process.env.REACT_APP_API_PETCOZOO}/providers/createProvider`, //
          providerEnvia,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
          },
        );
      } catch (errCreate) {
        console.error("No se pudo crear el proveedor:", errCreate);
        Swal.fire({
          title: "No se pudo crear el proveedor",
          text:
            errCreate.response?.data?.message ||
            errCreate.response?.data?.replyText ||
            "Ocurrió un error, inténtalo de nuevo.",
          icon: "error",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Aceptar",
        });
        return; // se detiene aquí — no tiene caso asignar clusters a algo
        // que no se creó
      }
      const body = {
        clusters: arrClusterSeleccionado,
        provider: {
          proveedor: newProvider.idNumber,
          nameProvider: newProvider.nameProvider,
        },
      };

      let clustersOk = true;
      try {
        await axios.post(
          `${process.env.REACT_APP_API_PETCOZOO}/providers/addProviderInCluster`,
          body,
        );
      } catch (errClusters) {
        clustersOk = false;
        console.error("No se pudieron asignar los clusters:", errClusters);
      }

      let minimoOk = true;
      if (clustersOk && pendingMontoInicial) {
        try {
          const resTiendas = await axios.get(
            `${process.env.REACT_APP_API_PETCOZOO}/providers/getStoresForProvider/${newProvider.idNumber}`,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: token,
              },
            },
          );
          const tiendas = resTiendas.data?.data || [];
          if (tiendas.length > 0) {
            await axios.patch(
              `${process.env.REACT_APP_API_PETCOZOO}/providers/updateStoreMinimos`,
              {
                idNumber: newProvider.idNumber,
                minimos: tiendas.map((t) => ({
                  storeIdNumber: t.idNumber,
                  monto: pendingMontoInicial,
                })),
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  authorization: token,
                },
              },
            );
          }
        } catch (errMin) {
          minimoOk = false;
          console.error("No se pudo aplicar el monto inicial:", errMin);
        }
      }

      setArrClusterSeleccionado([]);
      setProveedor(newProvider.idNumber);
      hanldeProveedor(newProvider.idNumber);
      setVentanaProve(false);
      setMostrarSeleccion(false);
      setArrClusterSeleccionado([]);
      setSubCatMats([]);
      setNewProvider({
        idNumber: "",
        nameProvider: "",
        email: "",
        sucursalAsignada: "",
      });
      setSelectedSubcategory(null);
      setPendingMontoInicial(null);
      getAllProviders(token, null);
      if (!clustersOk) {
        Swal.fire({
          title: "Proveedor creado, pero sin clusters",
          text: "No se pudieron asignar los clusters seleccionados. Abre el proveedor y usa 'Editar clusters' para completarlo.",
          icon: "warning",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Entendido",
        });
      } else if (!minimoOk) {
        Swal.fire({
          title: "Proveedor y clusters creados",
          text: "No se pudo aplicar el mínimo inicial. Abre el proveedor y usa 'Editar mínimo' para capturarlo.",
          icon: "warning",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Entendido",
        });
      } else {
        Swal.fire({
          title: "Proveedor creado con éxito",
          icon: "success",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Aceptar",
          timer: 2000,
        });
      }
    }
  };

  const updateMaterial2 = async () => {
    const nuevosErrores = {};
    const materialesCompletos = providers[0].actualInventory.map((mat) => {
      const modificado = dataMaterialAuxiliar[mat.description];
      return modificado ? { ...mat, price: modificado.price } : mat;
    });

    materialesCompletos.forEach((material) => {
      const precio = parseFloat(material.price);
      if (isNaN(precio) || precio <= 0) {
        nuevosErrores[material.description] = true;
      }
    });

    if (Object.keys(nuevosErrores).length > 0) {
      setErrorPrices(nuevosErrores);
      Swal.fire({
        title: "Error al actualizar",
        text: "Hay materiales con precios vacíos o igual a 0, favor de revisar",
        icon: "error",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const materialesModificados = Object.values(dataMaterialAuxiliar).map(
      (m) => ({
        description: m.description,
        material: m.material,
        subCategoryId: m.subCategoryId,
        subCategoryName: m.subCategoryName,
        stock: parseInt(m.stock),
        price: parseFloat(m.price),
        active: true,
        _id: m._id,
      }),
    );

    try {
      await axios.patch(
        `${process.env.REACT_APP_API_PETCOZOO}/providers/updateManyMaterials/${proveedor}`,
        { materiales: materialesModificados },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        },
      );

      Swal.fire({
        title: "Actualización exitosa",
        text: "Los materiales fueron actualizados exitosamente",
        icon: "success",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      }).then(() => {
        setEditedPrices({});
        setErrorPrices({});
        setDataMaterialAuxiliar({});
        hanldeProveedor(proveedor);
      });
    } catch (error) {
      console.error("Error al enviar los cambios: ", error);
      Swal.fire({
        title: "Ocurrió un error al enviar los cambios.",
        icon: "error",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "swal-legal",
        },
      });
    }
  };

  const handleCreateMaterial = async (material) => {
    const errores = {
      description: !material.description,
      material: !material.material,
      subCategoryId: !material.subCategoryId,
      subCategoryName: !material.subCategoryName,
      price:
        !material.price ||
        isNaN(material.price) ||
        Number(material.price) <= 0 ||
        /^0\d+/.test(material.price),
      nombreCientifico: ["1040202", "1040304", "1040201"].includes(
        material.subCategoryId,
      )
        ? !material.nombreCientifico
        : false,
      guia: ["1040202", "1040304", "1040201"].includes(material.subCategoryId)
        ? !material.selectedGuia && !material.file
        : false,
    };

    const hayErrores = Object.values(errores).some((v) => v === true);
    if (hayErrores) {
      setErrNewMaterial(errores);
      return;
    }

    let opt;

    if (
      idSubcategoriaNuevo === "1040202" ||
      idSubcategoriaNuevo === "1040304" ||
      idSubcategoriaNuevo === "1040201"
    ) {
      Swal.fire({
        title: "¿Deseas actualizar la información de la guía de cuidado?",
        icon: "info",
        iconColor: "#001F5B",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Si",
        confirmButtonColor: "#001F5B",
        denyButtonText: "No",
        denyButtonColor: "#415477",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          opt = "1";
        } else if (result.isDenied) {
          opt = "2";
        }
      });
    } else {
    }
    try {
      const filtrados = clusters.filter((cluster) =>
        cluster.providers.some((p) => p.proveedor === proveedor),
      );
      const clustersEnvia = filtrados.map((cluster) => cluster.name);

      await createMaterial(
        token,
        parseInt(proveedor),
        {
          description: material.description,
          material: material.material,
          subCategoryId: material.subCategoryId,
          subCategoryName: material.subCategoryName,
          stock: 0,
          price: parseFloat(material.price),
          nombreCientifico: material.nombreCientifico || "",
        },
        clustersEnvia,
        material.nombreCientifico,
        material.file,
        material.selectedGuia,
      );

      setErrNewMaterial({
        description: false,
        dupli: false,
        material: false,
        subCategoryId: false,
        subCategoryName: false,
        price: false,
        nombreCientifico: false,
        guia: false,
      });
      setAltaMaterial(false);
      setIdNuevo("");
      setMaterialNuevo();
      setIdSubCategoriaNuevo();
      setNombreCategoriaNuevo();
      setPrecioNuevo();
      setNewSubcategories(null);
      setNombreCientifo();
      setFile(null);
      setSelectedGuia("");

      await getProviderById(token, proveedor);
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Ocurrió un error al crear el material",
        icon: "error",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const handleCargarMaterial = async (material) => {
    const filtrados = clusters.filter((cluster) =>
      cluster.providers.some((p) => p.proveedor === proveedor),
    );
    const clustersEnvia = filtrados.map((cluster) => {
      return cluster.name;
    });
    let newMat = { ...selectedMat, price: precioNuevo };

    const errores = {
      subCat: !selectedSubcategory,
      material: !selectedMat,
      price:
        !precioNuevo ||
        isNaN(precioNuevo) ||
        Number(precioNuevo) <= 0 ||
        /^0\d+/.test(precioNuevo),
    };
    const hayErrores = Object.values(errores).some((v) => v === true);
    if (hayErrores) {
      setErrCargaMaterial(errores);
    } else {
      addMatProvider(token, proveedor, newMat, clustersEnvia);
      setSelectedSubcategory(null);
      setCargaMaterial(false);
      setErrCargaMaterial({
        subCat: false,
        material: false,
        price: false,
      });
      setPrecioNuevo(null);
      setSelectedMat(null);
    }
  };

  const handleFilter = (cluster, filtro) => {
    let auxTable = [...dataProvider];

    const filterByCluster = (data, cluster) => {
      return data.filter(
        (provider) =>
          Array.isArray(provider.clusters) &&
          provider.clusters.includes(cluster),
      );
    };

    const filterByString = (data, text) => {
      const lowerText = text.toLowerCase();
      return data.filter(
        (provider) =>
          provider.name.toLowerCase().includes(lowerText) ||
          provider.idNumber.toLowerCase().includes(lowerText),
      );
    };

    if (cluster || cluster === "") {
      if (cluster) {
        auxTable = filterByCluster(auxTable, cluster);
      }
      if (selectedFiltro) {
        auxTable = filterByString(auxTable, selectedFiltro);
      }
    } else if (filtro || filtro === "") {
      if (filtro) {
        auxTable = filterByString(auxTable, filtro);
      }
      if (clusterSelect) {
        auxTable = filterByCluster(auxTable, clusterSelect);
      }
    }
    setDataTable(auxTable);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const getClusters = async () => {
    setMostrarSpiner(true);
    let apiHost = process.env.REACT_APP_API_PETCOZOO;
    const headers = {
      "Content-Type": "application/json",
      authorization: token,
    };

    try {
      let res = await axios.get(`${apiHost}/providers/getProviderByCluster`, {
        headers,
      });
      setClusters(res.data);
      setMostrarSpiner(false);
    } catch (error) {
      setMostrarSpiner(false);
    }
  };

  // Trata "sin el campo active" como activo — mismo criterio que ya usas en
  // el backend ($or: [{active:true},{active:{$exists:false}}]).
  const isProviderActiveInCluster = (p) => p.active !== false;

  const filterProvidersByCluster = () => {
    let providersAux = providers.map((proveedor) => ({
      ...proveedor,
      clusters: [],
    }));
    let providersFiltrados = providersAux.map((element) => {
      let newClusters = [...element.clusters];

      clusters.forEach((cluster) => {
        if (
          cluster.providers.some(
            (provider) =>
              provider.proveedor == element.idNumber &&
              isProviderActiveInCluster(provider),
          )
        ) {
          newClusters = [...newClusters, cluster.name];
        }
      });
      setMostrarSpiner(false);
      return { ...element, clusters: newClusters };
    });

    setDataProvider(providersFiltrados);
    setDataTable(providersFiltrados);
  };

  const handleDeleteMaterial = async (token, proveedor, matDescription) => {
    Swal.fire({
      title: "Eliminar material",
      icon: "warning",
      text: "Esta acción será permanente",
      confirmButtonColor: "#00205B",
      confirmButtonText: "Aceptar",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteMaterial(token, proveedor, matDescription.toString());
        await getProviderById(token, proveedor);
      } else {
        Swal.close();
      }
    });
  };

  const handleDesactiveProvider = async (provider) => {
    Swal.fire({
      title: `¿Eliminar proveedor ${provider.name}?`,
      icon: "warning",
      text: "Esta acción será permanente",
      confirmButtonColor: "#00205B",
      confirmButtonText: "Aceptar",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        desactiveProvider(token, provider.idNumber);
      } else {
        Swal.close();
      }
    });
  };

  const fetchData = async () => {
    await getAllProviders(token, null);
    await getClusters();
  };

  useEffect(() => {
    if (proveedor) {
      getProviderById(token, proveedor);
    }
    if (
      message &&
      message.text !== "Material con ID duplicado" &&
      message.text !== "El material ya existe en la base de materiales"
    ) {
      setAltaMaterial(false);
      setCargaMaterial(false);
    }
    if (
      message &&
      message.text == "El material ya existe en la base de materiales"
    ) {
      setErrNewMaterial((prev) => ({
        ...prev,
        dupli: true,
      }));
    }
  }, [message]);

  useEffect(() => {
    if (!token) return;
    const fetchData = async () => {
      await getAllProviders(token, null);
      await getClusters();
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    if (providers.length > 0 && clusters.length > 0) {
      filterProvidersByCluster();
    }
  }, [providers, clusters]);

  const handleSubcategoriaChange = async (e) => {
    const selectedId = e.target.value;

    setErrNewMaterial((prev) => ({
      ...prev,
      subCategoryId: false,
      subCategoryName: false,
    }));
    if (!selectedId) {
      setIdSubCategoriaNuevo("");
      setNombreCategoriaNuevo("");
      setIdNuevo("");
      setMaterialNuevo("");
      return;
    }

    const selectedObj = newSubcategories.find(
      (sub) => sub.SUBCATEGORIA_ID === selectedId,
    );
    setIdSubCategoriaNuevo(selectedId);
    setNombreCategoriaNuevo(selectedObj.SUBCATEGORIA_NOMBRE);
    setIdNuevo("");
    setMaterialNuevo();
    setGuias([]);
    setFile(null);
    setSelectedGuia("");
    setPreviewUrl(null);

    if (
      selectedId === "1040202" ||
      selectedId === "1040304" ||
      selectedId === "1040201"
    ) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/getCareGuides/${selectedId}`,
          {
            headers: {
              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
              authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            },
          },
        );

        if (response.data.data.length > 0) {
          setGuias(response.data.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  // ---- Detalle / edición de proveedor (clusters + mínimos) ----
  const getClusterNamesForProvider = (idNumber) => {
    return clusters
      .filter((cluster) =>
        cluster.providers.some(
          (p) => p.proveedor === idNumber && isProviderActiveInCluster(p),
        ),
      )
      .map((cluster) => cluster.name);
  };

  const handleAbrirDetalle = (provider) => {
    setProveedorEnDetalle(provider);
    setDetalleProveedorAbierto(true);
  };

  const handleCerrarDetalle = () => {
    setDetalleProveedorAbierto(false);
    setProveedorEnDetalle(null);
  };

  const handleGuardarClusters = async (idNumber, clustersSeleccionados) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_PETCOZOO}/providers/updateProviderClusters`,
        {
          idNumber,
          nameProvider:
            proveedorEnDetalle?.name || proveedorEnDetalle?.nameProvider,
          clusters: clustersSeleccionados,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        },
      );
      await getClusters();
      setEditModal(null);
      Swal.fire({
        title: "Clusters actualizados",
        icon: "success",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      Swal.fire({
        title: "No se pudo actualizar los clusters",
        icon: "error",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const TablaSeleccionMaterial = ({ subCatMats, setSubCatMats, onClose }) => {
    const [subCatMatsEdited, setSubCatMatsEdited] = useState(subCatMats);
    const [searchTerm, setSearchTerm] = useState("");

    const toggleChecked = useCallback((id) => {
      setSubCatMatsEdited((prev) =>
        prev.map((item) =>
          item.idOriginal === id ? { ...item, checked: !item.checked } : item,
        ),
      );
    }, []);

    const filteredMaterials = useMemo(() => {
      return subCatMatsEdited.filter((mat) => {
        const term = searchTerm.toLowerCase();
        return (
          mat.MATERIAL_ID?.toString().toLowerCase().includes(term) ||
          mat.MATERIAL_NOMBRE?.toLowerCase().includes(term) ||
          mat.SUBCATEGORIA_NOMBRE?.toLowerCase().includes(term) ||
          mat.price?.toString().toLowerCase().includes(term)
        );
      });
    }, [searchTerm, subCatMatsEdited]);

    const MaterialRow = React.memo(({ material, toggleChecked }) => {
      return (
        <TableRow key={material.idOriginal}>
          <StyledTableCell>{material.MATERIAL_ID}</StyledTableCell>
          <StyledTableCell>{material.MATERIAL_NOMBRE}</StyledTableCell>
          <StyledTableCell>{material.SUBCATEGORIA_NOMBRE}</StyledTableCell>
          <StyledTableCell>
            <Checkbox
              checked={material.checked}
              onChange={() => toggleChecked(material.idOriginal)}
            />
          </StyledTableCell>
        </TableRow>
      );
    });

    return (
      <div
        key="1234"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 3,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          gap: "2rem",
        }}>
        <Card
          style={{
            padding: "2rem",
            width: "80%",
            maxHeight: "90vh",
            overflow: "auto",
          }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#00205b"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            onClick={onClose}>
            <path d="M9 14l-4 -4l4 -4" />
            <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
          </svg>

          <Typography
            variant="h5"
            color="primary"
            style={styles.textin}
            sx={{ marginBottom: "0.5rem" }}>
            {newProvider.nameProvider}
          </Typography>
          <TextField
            label="Buscar"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: "1rem" }}
          />
          {loadingTablaSubcat && (
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}>
              <ClipLoader color="#00205B" size="50px" />
            </div>
          )}

          {(!loadingTablaSubcat && filteredMaterials.length) > 0 && (
            <TableContainer sx={{ height: "45vh" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Material</StyledTableCell>
                    <StyledTableCell>SubCategoría</StyledTableCell>
                    <StyledTableCell>
                      Todos{" "}
                      <Checkbox
                        sx={{
                          color: "white",
                          "&.Mui-checked": {
                            color: "white",
                          },
                        }}
                        onChange={(e) => {
                          const newValue = e.target.checked;
                          setSubCatMatsEdited((prev) =>
                            prev.map((item) => ({
                              ...item,
                              checked: newValue,
                            })),
                          );
                        }}
                      />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMaterials.map((material) => (
                    <MaterialRow
                      key={material.idOriginal}
                      material={material}
                      toggleChecked={toggleChecked}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "1rem",
              marginTop: "1rem",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "1rem",
            }}>
            <CustomButton
              sx={{ width: "20%" }}
              onClick={async () => {
                await handleCreateProvider(subCatMatsEdited);
                //await getClusters();
              }}>
              Confirmar
            </CustomButton>
            <CustomButton
              sx={{ backgroundColor: "#AFAFAF", width: "20%" }}
              onClick={() => {
                setVentanaProve(false);
                setMostrarSeleccion(false);
                setArrClusterSeleccionado([]);
                setSubCatMats([]);
                setSelectedSubcategory(null);
                setNewProvider({
                  idNumber: "",
                  nameProvider: "",
                  email: "",
                  sucursalAsignada: "",
                });
                setPendingMontoInicial(null);
              }}>
              Cancelar
            </CustomButton>
          </div>
        </Card>
      </div>
    );
  };

  const opcionesDebug = subCatMats.filter(
    (sub) =>
      !providers[0]?.actualInventory?.some(
        (item) => item.description === sub.MATERIAL_ID && item.active === true,
      ),
  );

  return (
    <div style={styles.content}>
      {message && (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={true}
          onClose={clearMessage}
          time={3000}
        />
      )}

      {loadingProviders && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            gap: "2rem",
          }}>
          {" "}
          <ClipLoader color="#00205B" size="100px" />
        </div>
      )}
      <div className="div-administrador">
        <AgregarProveedorModal
          open={!!ventanaProve && !mostrarSeleccion}
          clusters={clusters}
          subcategories={subcategories || []}
          onContinue={handleShowTable}
          onCancel={() => setVentanaProve(false)}
        />

        {ventanaProve && mostrarSeleccion && (
          <TablaSeleccionMaterial
            subCatMats={subCatMats}
            setSubCatMats={setSubCatMats}
            onClose={() => setMostrarSeleccion(false)}
          />
        )}

        <DetalleProveedorModal
          open={detalleProveedorAbierto}
          provider={proveedorEnDetalle}
          clusterNames={
            proveedorEnDetalle
              ? getClusterNamesForProvider(proveedorEnDetalle.idNumber)
              : []
          }
          onClose={handleCerrarDetalle}
          onEditClusters={() => setEditModal("clusters")}
          onEditMinimos={() => setEditModal("minimos")}
        />

        <EditarClustersModal
          open={editModal === "clusters"}
          provider={proveedorEnDetalle}
          allClusters={clusters}
          initialSelected={
            proveedorEnDetalle
              ? getClusterNamesForProvider(proveedorEnDetalle.idNumber)
              : []
          }
          onSave={handleGuardarClusters}
          onCancel={() => setEditModal(null)}
        />

        <EditarMinimosModal
          open={editModal === "minimos"}
          provider={proveedorEnDetalle}
          token={token}
          onClose={() => setEditModal(null)}
        />

        <div className="div-adm-header">
          <div>
            {proveedor && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#00205b"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                onClick={(e) => {
                  getAllProviders(token, null);
                  setProveedor(null);
                  setEditedPrices({});
                  setErrorPrices({});
                }}
                style={{
                  cursor: "pointer",
                }}>
                <path d="M9 14l-4 -4l4 -4" />
                <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
              </svg>
            )}
          </div>
          <div className="div-adm-title">
            <p>Módulo de administración</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-password-user"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              strokeWidth="1.2"
              stroke="#00205b"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
              <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
            </svg>
          </div>

          <div>
            <p></p>
          </div>
        </div>

        {proveedor && providers && providers.length > 0 ? (
          <>
            <div className="div-adm-mat">
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  width: "100%",
                  justifyContent: "center",
                  textAlign: "center",
                }}>
                <Typography variant="h5" color="primary" style={styles.textin}>
                  {(providers &&
                    providers[0].actualInventory &&
                    providers[0].actualInventory.length) > 0
                    ? `Inventario disponible proveedor ${providers[0]?.nameProvider}`
                    : !providers[0]?.nameProvider
                      ? `Cargando proveedor`
                      : `Aún no hay inventario disponible para el proveedor: "${providers[0]?.nameProvider}"`}
                </Typography>
              </div>

              <div className="div-table-prov">
                {(providers &&
                  providers[0].actualInventory &&
                  providers[0].actualInventory.length) > 0 && (
                  <>
                    <Typography color="primary">
                      {providers[0].actualInventory.length} materiales en el
                      inventario
                    </Typography>
                    <TableContainer className="table-prov">
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell align="center">ID</StyledTableCell>
                            <StyledTableCell align="center">
                              Material
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Subcategoría
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Precio
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Eliminar
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody style={{ maxHeight: "20vh" }}>
                          {providers &&
                            providers[0]?.actualInventory
                              ?.filter((material) => material.active)
                              .map((material, rowIndex) => {
                                return (
                                  <TableRow key={rowIndex}>
                                    <StyledTableCell>
                                      {material.description}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {material.material}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {material.subCategoryName}
                                    </StyledTableCell>
                                    <div
                                      align="center"
                                      style={styles.borderBottomTr}>
                                      <TextField
                                        key={material.id}
                                        id={`material-${material.id}`}
                                        value={
                                          editedPrices[material.description] ??
                                          material.price
                                        }
                                        error={
                                          errorPrices[material.description] ||
                                          false
                                        }
                                        onChange={(e) =>
                                          handleChange(e, material)
                                        }
                                      />
                                    </div>
                                    <StyledTableCell align="center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        style={{
                                          cursor: "pointer",
                                          justifyContent: "center",
                                        }}
                                        onClick={async () => {
                                          await handleDeleteMaterial(
                                            token,
                                            parseInt(proveedor),
                                            material.description.toString(),
                                          );
                                        }}
                                        stroke="red"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        width="24"
                                        height="24"
                                        stroke-width="2">
                                        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"></path>
                                        <path d="M9 9l6 6m0 -6l-6 6"></path>
                                      </svg>
                                    </StyledTableCell>
                                  </TableRow>
                                );
                              })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}

                {selectedGuia && viewGuia && (
                  <div className="overlay-guia">
                    <div className="popup-guia">
                      <div className="btn-cerrar-popup">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={closeGuia}
                          title="Cerrar Ventana">
                          x
                        </span>
                      </div>

                      <img
                        onContextMenu={(e) => e.preventDefault()}
                        src={previewUrl}
                        alt="Guía seleccionada"
                        style={{
                          width: "100%",
                          maxHeight: "200px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  </div>
                )}

                {altaMaterial && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 1000,
                      backgroundColor: "rgba(58, 58, 58, 0.8)",
                      gap: "2rem",
                    }}>
                    <Card className="container-add-mat">
                      <Typography
                        variant="h5"
                        color="primary"
                        style={styles.textin}>
                        Alta de material
                      </Typography>

                      <div className="div-carga-mat">
                        <div style={styles.divForm}>
                          <p
                            style={
                              errNewMaterial.subCategoryName ||
                              errNewMaterial.subCategoryId
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Subcategoría:{" "}
                          </p>

                          <Select
                            value={idSubcategoriaNuevo || ""}
                            error={
                              errNewMaterial.subCategoryName ||
                              errNewMaterial.subCategoryId
                            }
                            onChange={handleSubcategoriaChange}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  overflow: "auto",
                                  zIndex: "10000",
                                },
                              },
                            }}>
                            <MenuItem value="">Seleccionar</MenuItem>
                            {newSubcategories &&
                              newSubcategories.map((sub) => (
                                <MenuItem key={sub} value={sub.SUBCATEGORIA_ID}>
                                  {sub.SUBCATEGORIA_NOMBRE}
                                </MenuItem>
                              ))}
                          </Select>

                          {(errNewMaterial.subCategoryName ||
                            errNewMaterial.subCategoryId) && (
                            <span style={{ fontSize: "0.7rem", color: "red" }}>
                              Obligatorio
                            </span>
                          )}
                        </div>

                        <div style={styles.divForm}>
                          <p
                            style={
                              errNewMaterial.material
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Nombre del material:
                          </p>
                          <Autocomplete
                            options={materialesFiltrados}
                            getOptionLabel={(option) =>
                              option.MATERIAL_NOMBRE || ""
                            }
                            value={
                              materialesFiltrados.find(
                                (mat) => mat.MATERIAL_ID === idNuevo,
                              ) || null
                            }
                            onChange={(e, newValue) => {
                              setErrNewMaterial((prev) => ({
                                ...prev,
                                material: false,
                                description: false,
                              }));
                              setIdNuevo(newValue ? newValue.MATERIAL_ID : "");
                              setMaterialNuevo(
                                newValue ? newValue.MATERIAL_NOMBRE : "",
                              );
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.MATERIAL_ID === value?.MATERIAL_ID
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Buscar material..."
                                error={errNewMaterial.material}
                                autoComplete="off"
                                name="carga-material-nombre" // nombre único, evita que el navegador guarde/sugiera valores
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password", // truco extra: algunos navegadores ignoran "off" y respetan "new-password"
                                }}
                              />
                            )}
                            noOptionsText="Sin resultados"
                            ListboxProps={{
                              style: { zIndex: 10000 },
                            }}
                            fullWidth
                          />
                          {errNewMaterial.material && (
                            <span
                              style={{
                                fontSize: "0.7rem",
                                color: "red",
                              }}>
                              Obligatorio
                            </span>
                          )}
                        </div>

                        <div style={styles.divForm}>
                          <p>Id del material:</p>
                          <TextField disabled value={idNuevo ? idNuevo : ""} />
                        </div>

                        <div style={styles.divForm}>
                          <p
                            style={
                              errNewMaterial.price
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Precio:
                          </p>
                          <TextField
                            type="number"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                style: {
                                  MozAppearance: "textfield",
                                },
                              },
                              sx: {
                                "& input::-webkit-outer-spin-button": {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                                "& input::-webkit-inner-spin-button": {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                              },
                            }}
                            onKeyDown={(e) => {
                              if (["-", "e", "+"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            helperText={
                              errNewMaterial.price ? "Obligatorio" : ""
                            }
                            error={errNewMaterial.price}
                            onChange={(e) => {
                              setErrNewMaterial((prev) => ({
                                ...prev,
                                price: false,
                              }));
                              setPrecioNuevo(e.target.value);
                            }}></TextField>
                        </div>

                        {(idSubcategoriaNuevo === "1040202" ||
                          idSubcategoriaNuevo === "1040304" ||
                          idSubcategoriaNuevo === "1040201") && (
                          <>
                            <div style={styles.divForm}>
                              <p
                                style={
                                  errNewMaterial.guia
                                    ? { color: "red" }
                                    : { color: "black" }
                                }>
                                Guía de cuidado (img)
                              </p>

                              <div className="div-file-guia">
                                <FormControl fullWidth>
                                  <Select
                                    value={selectedGuia}
                                    onChange={handleGuiaChange}
                                    error={errNewMaterial.guia}>
                                    {guias.map((g, index) => (
                                      <MenuItem key={index} value={g.name}>
                                        {g.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={openGuia}
                                  width="32"
                                  height="32"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#00205b"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                  <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                                </svg>
                              </div>

                              <Typography
                                component="label"
                                color="primary"
                                sx={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  width: "fit-content",
                                }}>
                                Cargar nueva guía
                                <input
                                  hidden
                                  type="file"
                                  accept="image/*"
                                  ref={fileInputRef}
                                  onChange={handleArchivoChange}
                                />
                              </Typography>

                              {file && (
                                <div className="div-file-guia">
                                  <span variant="body2" noWrap>
                                    {file.name}
                                  </span>

                                  <svg
                                    onClick={handleDeleteFile}
                                    style={{ cursor: "pointer" }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="23"
                                    height="23"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="rgba(153, 18, 41, 1)"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M4 7l16 0" />
                                    <path d="M10 11l0 6" />
                                    <path d="M14 11l0 6" />
                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                  </svg>
                                </div>
                              )}
                            </div>

                            <div style={styles.divForm}>
                              <p
                                style={
                                  errNewMaterial.nombreCientifico
                                    ? { color: "red" }
                                    : { color: "black" }
                                }>
                                Nombre científico
                              </p>
                              <TextField
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                    style: {
                                      MozAppearance: "textfield",
                                    },
                                  },
                                  sx: {
                                    "& input::-webkit-outer-spin-button": {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                    "& input::-webkit-inner-spin-button": {
                                      WebkitAppearance: "none",
                                      margin: 0,
                                    },
                                  },
                                }}
                                helperText={
                                  errNewMaterial.nombreCientifico
                                    ? "Obligatorio"
                                    : ""
                                }
                                error={errNewMaterial.nombreCientifico}
                                onChange={(e) => {
                                  setErrNewMaterial((prev) => ({
                                    ...prev,
                                    nombreCientifico: false,
                                  }));
                                  setNombreCientifo(e.target.value);
                                }}></TextField>
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                          paddingTop: "10px",
                        }}>
                        <CustomButton
                          className="btn-update"
                          onClick={async () => {
                            await handleCreateMaterial({
                              description: idNuevo,
                              material: materialNuevo,
                              subCategoryId: idSubcategoriaNuevo,
                              subCategoryName: nombreCategoriaNuevo,
                              stock: 0,
                              price: precioNuevo,
                              nombreCientifico: nombreCientifico,
                              file: file,
                              selectedGuia: selectedGuia,
                            });
                          }}>
                          CARGAR MATERIAL
                        </CustomButton>

                        <CustomButton
                          className="btn-update"
                          sx={{ backgroundColor: "#afafaf" }}
                          onClick={() => {
                            setErrNewMaterial({
                              description: false,
                              dupli: false,
                              material: false,
                              subCategoryId: false,
                              subCategoryName: false,
                              price: false,
                              nombreCientifico: false,
                              guia: false,
                            });
                            setAltaMaterial(false);
                            setIdNuevo("");
                            setMaterialNuevo();
                            setIdSubCategoriaNuevo();
                            setNombreCategoriaNuevo();
                            setPrecioNuevo();
                            setNewSubcategories(null);
                            setNombreCientifo();
                            setFile(null);
                            setSelectedGuia("");
                            setPreviewUrl(null);
                          }}>
                          Cancelar
                        </CustomButton>
                      </div>
                    </Card>
                  </div>
                )}

                {cargaMaterial && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 1000,
                      backgroundColor: "rgba(58, 58, 58, 0.8)",
                      gap: "2rem",
                    }}>
                    <Card className="container-carga-mat">
                      <Typography
                        variant="h5"
                        color="primary"
                        style={styles.textin}>
                        Carga de material:
                      </Typography>
                      <div className="div-carga-mat">
                        <div style={styles.divForm}>
                          <p
                            style={
                              errCargaMaterial.subCat
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Subcategoría:{" "}
                          </p>
                          <FormControl fullWidth>
                            <Select
                              error={errCargaMaterial.subCat}
                              style={{ cursor: "pointer" }}
                              value={selectedSubcategory}
                              onChange={(e) => {
                                setSelectedMat(null);
                                filterBySubcategory(e.target.value);
                                setSelectedSubcategory(e.target.value);
                                setErrCargaMaterial((prev) => ({
                                  ...prev,
                                  subCat: false,
                                }));
                              }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    overflow: "auto",
                                    zIndex: "10000",
                                  },
                                },
                              }}>
                              <MenuItem value="">Seleccionar</MenuItem>
                              {subcategories &&
                                subcategories.map((sub) => (
                                  <MenuItem
                                    key={sub}
                                    value={sub.SUBCATEGORIA_NOMBRE}>
                                    {sub.SUBCATEGORIA_NOMBRE}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                          {errCargaMaterial.subCat && (
                            <span style={{ fontSize: "0.7rem", color: "red" }}>
                              Obligatorio
                            </span>
                          )}
                        </div>

                        <div style={styles.divForm}>
                          <p
                            style={
                              errCargaMaterial.material
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Nombre del material:
                          </p>
                          <Autocomplete
                            options={subCatMats.filter(
                              (sub) =>
                                !providers[0]?.actualInventory?.some(
                                  (item) =>
                                    item.description === sub.MATERIAL_ID &&
                                    item.active === true,
                                ),
                            )}
                            getOptionLabel={(option) =>
                              option.MATERIAL_NOMBRE || ""
                            }
                            value={selectedMat || null}
                            onChange={(_, newValue) => {
                              setSelectedMat(newValue);
                              setErrCargaMaterial((prev) => ({
                                ...prev,
                                material: false,
                              }));
                            }}
                            noOptionsText="Sin opciones"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={errCargaMaterial.material}
                                placeholder="Buscar material..."
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option.MATERIAL_ID === value.MATERIAL_ID
                            }
                          />
                          {errCargaMaterial.material && (
                            <span style={{ fontSize: "0.7rem", color: "red" }}>
                              Obligatorio
                            </span>
                          )}
                        </div>

                        <div style={styles.divForm}>
                          <p>Id del material:</p>
                          <TextField
                            disabled
                            value={
                              selectedMat && selectedMat.MATERIAL_ID
                                ? selectedMat.MATERIAL_ID
                                : ""
                            }
                          />
                        </div>

                        <div style={styles.divForm}>
                          <p
                            style={
                              errCargaMaterial.price
                                ? { color: "red" }
                                : { color: "black" }
                            }>
                            Precio:
                          </p>
                          <TextField
                            fullWidth
                            type="number"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                style: {
                                  MozAppearance: "textfield",
                                },
                              },
                              sx: {
                                "& input::-webkit-outer-spin-button": {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                                "& input::-webkit-inner-spin-button": {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                              },
                            }}
                            onKeyDown={(e) => {
                              if (["-", "e", "+"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            helperText={
                              errCargaMaterial.price ? "Obligatorio" : ""
                            }
                            error={errCargaMaterial.price}
                            onChange={(e) => {
                              setErrCargaMaterial((prev) => ({
                                ...prev,
                                price: false,
                              }));
                              setPrecioNuevo(e.target.value);
                            }}></TextField>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "",
                          gap: "1rem",
                        }}>
                        <CustomButton
                          className="btn-add-prov"
                          onClick={async (e) => {
                            handleCargarMaterial();
                          }}>
                          Aceptar
                        </CustomButton>
                        <CustomButton
                          className="btn-add-prov"
                          sx={{ backgroundColor: "#afafaf" }}
                          onClick={(e) => {
                            setSelectedSubcategory(null);
                            setCargaMaterial(false);
                            setErrCargaMaterial({
                              subCat: false,
                              material: false,
                              price: false,
                            });
                            setPrecioNuevo(null);
                            setSelectedMat(null);
                          }}>
                          Cancelar
                        </CustomButton>
                      </div>
                    </Card>
                  </div>
                )}
              </div>
            </div>

            {loadingAlta ? (
              <div>
                <ClipLoader color="001F5B" size="50px" />
              </div>
            ) : (
              <>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    getNewSubcategories("1");
                  }}>
                  Consultar nuevos materiales
                </Button>
              </>
            )}
            <Button
              onClick={(e) => {
                e.preventDefault();
                setCargaMaterial(true);
              }}>
              Carga de material
            </Button>
            {hayCambios && (
              <CustomButton className="btn-update" onClick={updateMaterial2}>
                Modificar material(es)
              </CustomButton>
            )}
          </>
        ) : (
          <>
            {" "}
            {!mostrarSpiner && (
              <div className="div-adm-prov">
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    width: "100%",
                    justifyContent: "center",
                  }}>
                  <Typography
                    variant="h5"
                    color="primary"
                    style={styles.textin}>
                    Proveedores disponibles
                  </Typography>
                </div>
                <div className="div-container-prov">
                  <TextField
                    label="Buscar proveedor"
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "15px" }}
                    onChange={(e) => {
                      const filtro = e.target.value;
                      setSelectedFiltro(filtro);
                    }}
                  />
                  <div className="div-table-prov">
                    <TableContainer className="table-prov">
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell style={{ width: "28%" }}>
                              Proveedor
                            </StyledTableCell>
                            <StyledTableCell style={{ width: "18%" }}>
                              ID
                            </StyledTableCell>
                            <StyledTableCell style={{ width: "22%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 4,
                                }}>
                                <span style={{ fontWeight: 500 }}>Cluster</span>
                                <Select
                                  value={clusterSelect}
                                  onChange={(e) => {
                                    const selectedCluster = e.target.value;
                                    setClusterSelect(selectedCluster);
                                    handleFilter(selectedCluster, "");
                                  }}
                                  sx={{
                                    backgroundColor: "#00205b",
                                    color: "white",
                                    fontSize: "0.8rem",
                                    padding: "4px 8px",
                                    maxHeight: "2rem",
                                    cursor: "pointer",
                                    "& .MuiSelect-icon": {
                                      color: "white",
                                    },
                                  }}>
                                  <MenuItem value="">Seleccionar</MenuItem>
                                  {clusters.map((cluster) => (
                                    <MenuItem
                                      key={cluster.name}
                                      value={cluster.name}>
                                      {cluster.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "17%" }}
                              align="center">
                              Mínimo
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "15%" }}
                              align="center">
                              Acciones
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody style={{ maxHeight: "20vh" }}>
                          {filteredProveedores &&
                            filteredProveedores.map(
                              (provider, index) =>
                                provider.active === true && (
                                  <TableRow key={index}>
                                    <StyledTableCell
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        setProveedor(provider.idNumber);
                                        hanldeProveedor(provider.idNumber);
                                      }}>
                                      {provider.name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        setProveedor(provider.idNumber);
                                        hanldeProveedor(provider.idNumber);
                                      }}>
                                      {provider.idNumber}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                      <span
                                        className="badge-cluster"
                                        onClick={() =>
                                          handleAbrirDetalle(provider)
                                        }>
                                        <span className="badge-dot" />
                                        {(provider.clusters || []).length}{" "}
                                        cluster
                                        {(provider.clusters || []).length === 1
                                          ? ""
                                          : "s"}
                                      </span>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                      <span
                                        className="badge-minimo"
                                        onClick={() =>
                                          handleAbrirDetalle(provider)
                                        }>
                                        Ver mínimo
                                      </span>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                      <IconButton
                                        aria-label="eliminar"
                                        sx={{
                                          color: "#991229",
                                          backgroundColor: "transparent",
                                          "&:hover": {
                                            backgroundColor: "#FCEBEB",
                                          },
                                        }}
                                        onClick={() =>
                                          handleDesactiveProvider(provider)
                                        }>
                                        <DeleteIcon />
                                      </IconButton>
                                    </StyledTableCell>
                                  </TableRow>
                                ),
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            )}
            <div style={{ display: "flex", gap: "1rem" }}>
              <CustomButton
                className="btn-update"
                onClick={(e) => {
                  setVentanaProve(true);
                }}>
                Agregar proveedor
              </CustomButton>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    users: state.users.users,
    providers: state.providers.providers,
    loadingProviders: state.providers.loading,
    token: state.users.uid,
    message: state.config.message,
  };
};

const mapDispatchToProps = {
  getAllProviders: ProvidersCreators.getAllProviders,
  getProviderById: ProvidersCreators.getProviderById,
  updateMaterial: ProvidersCreators.updateMaterial,
  createProvider: ProvidersCreators.createProvider,
  createMaterial: ProvidersCreators.createMaterial,
  deleteMaterial: ProvidersCreators.deleteMaterial,
  desactiveProvider: ProvidersCreators.desactiveProvider,
  addMatProvider: ProvidersCreators.addMatProvider,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministradorPage);
